import { Typography } from '@mui/material'
import { useContext } from 'react'

import { AppSettingsContext } from '../../Contexts'
import { Property, PropertyAction } from '../../Properties'

const DarkModeProperty: React.FC = () => {
  const { darkMode, enableDarkMode } = useContext(AppSettingsContext)

  const onClick = () => {
    enableDarkMode?.(!darkMode)
  }

  const action: PropertyAction = {
    name: 'Toggle',
    onClick,
  }

  return (
    <Property actions={[action]} tip="Use the dark mode theme" title="Dark Mode" value={darkMode}>
      <Typography variant="caption">{darkMode ? 'Enabled' : 'Disabled'}</Typography>
    </Property>
  )
}

export default DarkModeProperty
